<div class="ops-platform" [ngClass]="moduleColorClass">
  <div class="toast" *ngIf="showToast" [ngClass]="toastType">
    {{ toastMessage }}
  </div>

  <!-- TOP HEADER -->
  <div class="platform-header glass-panel">
    <div class="header-info">
      <h1>Operations Help Desk Platform</h1>
      <p>Raise tickets, update vessel data & manage requests in one place</p>
    </div>

    <div class="module-selector">
      <div class="module-pills">
        <button type="button" *ngFor="let mod of moduleOptions" 
                [class.active]="selectedModule === mod"
                (click)="onModuleChange(mod)"
                class="mod-pill">
          {{ mod }}
        </button>
      </div>
    </div>
  </div>

  <div class="platform-content">
    <!-- HELP DESK -->
    <div class="glass-card help-card">
      <div class="card-header">
        <div class="title-left">
          <h2>Help Desk Ticket</h2>
          <span class="live-dot" [class.active]="isDetailsFilled"></span>
        </div>
        <div class="ticket-badge">
          Active Ticket: <span>{{ dynamicTicketId }}</span>
        </div>
      </div>

      <form [formGroup]="ticketForm" class="card-body">
        
        <!-- LEFT COLUMN: Inputs -->
        <div class="form-inputs-section">
          <div class="form-row">
            <div class="field">
              <label>Ticket ID</label>
              <input [value]="dynamicTicketId" readonly class="readonly-input">
            </div>

            <div class="field">
              <label>Vessel Name</label>
              <input type="text" formControlName="vesselName" placeholder="Enter vessel name">
            </div>
          </div>

          <div class="field full-height-field">
            <label>Issue Description</label>
            <textarea formControlName="issue" placeholder="Write issue / remarks here"></textarea>
          </div>
        </div>

        <!-- RIGHT COLUMN: Upload, Status, Button -->
        <div class="form-actions-section">
          <div class="field">
            <label>Upload Screenshot</label>
            <label class="upload-box" [class.has-file]="isScreenshotAdded">
              <input type="file" hidden (change)="onTicketFileSelected($event)">
              <div class="upload-content">
                <div class="upload-icon">
                  <span *ngIf="!isScreenshotAdded">⬆</span>
                  <span *ngIf="isScreenshotAdded">✓</span>
                </div>
                <div class="upload-text">
                  <h3>{{ ticketFileName || 'Upload Issue Screenshot' }}</h3>
                  <p>{{ isScreenshotAdded ? 'Screenshot ready' : 'Drag & Drop / Browse File' }}</p>
                </div>
              </div>
            </label>
          </div>

          <div class="dynamic-success-box">
            <div class="status-item" [class.completed]="isDetailsFilled">
              <span class="icon">✓</span>
              <span class="text">Details Filled Successfully</span>
            </div>
            <div class="status-item" [class.completed]="isScreenshotAdded">
              <span class="icon">✓</span>
              <span class="text">Attachment Screenshot Added Successfully</span>
            </div>
            <div class="status-item" [class.completed]="isTicketRaised">
              <span class="icon">✓</span>
              <span class="text">Raise Ticket Successfully</span>
            </div>
          </div>

          <div class="btn-section">
            <button type="button" class="raise-btn" (click)="raiseTicket()" [disabled]="!isDetailsFilled || !isScreenshotAdded">
              RAISE TICKET
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>